import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React from "react";
import { Button } from "reactstrap";
import Profile from "./Profile.component";
import Start from "./GetStarted.component";
import UserImage from "./UserImage.component";
import LanguageAndRegin from "./languageAndRegin.component";
import Addresses from "./Address.component";
import { transferGetData } from "../transferData";
import { getUserInfo, initHost, initUserProfileApi, saveUserData } from "../../api";
import { userData, preData, finalData } from "../data";
import { transferPostData, isObjectValueEqual } from "../transferData";
import Modal from "../../../Basic/Modal";
import { IconBurgerMenu } from "@sfx/icons";
import { getTheme } from "../../../Basic/ThemeProvider";
import { getTransFunc } from '../../../Basic/SFxLocalization';
var prefix = "sfx-react-ui-user-profile";
var MenuList = [{
  id: 1,
  name: 'SFxUserProfileLanguageAndRegion',
  component: LanguageAndRegin
}, {
  id: 2,
  name: 'SFxUserProfileProfileInformation',
  component: Profile
}, {
  id: 3,
  name: 'SFxUserProfileAddresses',
  component: Addresses
}, {
  id: 4,
  name: 'SFxUserProfileUserImage',
  component: UserImage
}, {
  id: 5,
  name: 'SFxUserProfileGetStarted',
  component: Start
}];

var UserProfileComponent = /*#__PURE__*/function (_React$Component) {
  _inherits(UserProfileComponent, _React$Component);

  var _super = _createSuper(UserProfileComponent);

  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  function UserProfileComponent(props) {
    var _this;

    _classCallCheck(this, UserProfileComponent);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "$child", void 0);

    _defineProperty(_assertThisInitialized(_this), "componentWillUnmount", function () {
      _this.setState = function () {
        return;
      };
    });

    _defineProperty(_assertThisInitialized(_this), "wrapScrollHandle", function () {
      var $wrap = document.querySelector(".".concat(prefix, "-overflow"));

      if ($wrap && $wrap.scrollHeight > $wrap.offsetHeight) {
        _this.setState({
          scrollFlag: true
        });
      } else {
        _this.setState({
          scrollFlag: false
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "filterMenuList", function () {
      var showMenuList = _this.props.showMenuList;

      if (showMenuList) {
        if (!(showMenuList.length === 5)) {
          return;
        }

        var displayMenuList = MenuList.filter(function (item, index) {
          return showMenuList[index] === true;
        });

        _this.setState({
          displayMenuList: displayMenuList
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "childEvent", function (childDate) {
      _this.$child = childDate;
    });

    _defineProperty(_assertThisInitialized(_this), "onClose", function (needConfirmSave, closeCallBack) {
      if (_this.$child && _this.$child.saveData) {
        _this.$child.saveData();
      }

      finalData.languageRegion = userData.languageRegion;
      finalData.profileInfo = userData.profileInfo;
      finalData.addressInfo = userData.addressInfo;
      var isDataChanged = !isObjectValueEqual(preData, finalData);

      if (isDataChanged) {
        if (needConfirmSave) {
          _this.showConfirm(function () {
            // onOk
            _this.saveData();

            if (closeCallBack) {
              closeCallBack();
            }

            _this.destroy();
          }, function () {
            // onCancel
            if (closeCallBack) {
              closeCallBack();
            }

            _this.destroy();
          }, function () {
            // onClose
            if (closeCallBack) {
              closeCallBack();
            }

            _this.destroy();
          });
        } else {
          _this.saveData();

          if (closeCallBack) {
            closeCallBack();
          }

          _this.destroy();
        }
      } else {
        if (closeCallBack) {
          closeCallBack();
        }

        _this.destroy();
      }
    });

    _defineProperty(_assertThisInitialized(_this), "destroy", function () {
      _this.setState({
        show: false
      }, function () {
        if (_this.props.onCloseWrap) {
          _this.props.onCloseWrap();
        }
      });
    });

    _defineProperty(_assertThisInitialized(_this), "showConfirm", function (onOKCallback, onCancelCallback, onCloseCallback) {
      var trans = getTransFunc();
      Modal.confirm({
        title: trans('SFxUserProfileCompleteYourProfile'),
        content: trans('SFxUserProfileConfirmContent'),
        okText: trans('SFxUserProfileConfirmSave'),
        centered: true,
        onOk: function onOk() {
          if (onOKCallback) onOKCallback();
        },
        onClose: function onClose() {
          if (onCloseCallback) onCloseCallback();
        },
        onCancel: function onCancel() {
          if (onCancelCallback) onCancelCallback();
        }
      });
    });

    _defineProperty(_assertThisInitialized(_this), "saveData", function () {
      var data = transferPostData();

      if (userData.languageRegion.language && userData.staticSource.currentLanguage && userData.languageRegion.language.value !== userData.staticSource.currentLanguage.value) {
        if (_this.props.setLanguage) {
          _this.props.setLanguage(userData.languageRegion.language);
        }
      }

      saveUserData(data).then(function () {
        if (_this.props.saveSuccessCallback) {
          _this.props.saveSuccessCallback(data);
        }
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onClickMenuItem", function (currentItem) {
      var _this$state = _this.state,
          displayMenuList = _this$state.displayMenuList,
          isDisable = _this$state.isDisable;

      if (isDisable) {
        return;
      }

      if (_this.$child && _this.$child.saveData) {
        _this.$child.saveData();
      }

      _this.setState({
        activeMenu: currentItem,
        showMenuDropdown: false
      }, function () {
        displayMenuList.forEach(function (item, index) {
          if (item.id === currentItem.id) {
            _this.setState({
              currentIndex: index
            });
          }
        });

        _this.wrapScrollHandle();
      });
    });

    _defineProperty(_assertThisInitialized(_this), "setDisableState", function (state) {
      _this.setState({
        isDisable: state
      }, function () {
        _this.wrapScrollHandle();
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onBack", function () {
      var _this$state2 = _this.state,
          currentIndex = _this$state2.currentIndex,
          displayMenuList = _this$state2.displayMenuList;

      if (_this.$child && _this.$child.saveData) {
        _this.$child.saveData();
      }

      _this.setState({
        currentIndex: currentIndex - 1,
        activeMenu: displayMenuList[currentIndex - 1]
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onNext", function () {
      var displayMenuList = _this.state.displayMenuList;

      if (_this.$child && _this.$child.saveData) {
        _this.$child.saveData();
      }

      var currentItem = _this.state.activeMenu;
      var nextIndex = 0;
      displayMenuList.forEach(function (item, index) {
        if (item.id === currentItem.id) {
          if (index < displayMenuList.length - 1) {
            nextIndex = index + 1;
          }
        }
      });

      _this.setState({
        currentIndex: nextIndex,
        activeMenu: displayMenuList[nextIndex]
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onFinish", function () {
      _this.onClose(false, function () {
        if (_this.props && _this.props.onSolutionTour) {
          _this.props.onSolutionTour();
        }
      });
    });

    _defineProperty(_assertThisInitialized(_this), "uploadImageSuccess", function (imageUrl) {
      userData.userImg = imageUrl;
    });

    _defineProperty(_assertThisInitialized(_this), "deleteAvatarSuccess", function () {
      userData.userImg = "";
    });

    _defineProperty(_assertThisInitialized(_this), "reset", function () {
      if (_this.$child && _this.$child.resetData) {
        _this.$child.resetData();
      }
    });

    var _trans = getTransFunc();

    MenuList.forEach(function (i) {
      i.name = _trans(i.name);
    });
    _this.state = {
      show: false,
      showMenuDropdown: false,
      activeMenu: MenuList[0],
      isDisable: true,
      currentIndex: 0,
      scrollFlag: false,
      displayMenuList: MenuList
    };

    if (props) {
      initHost(props);
      initUserProfileApi(props);
    }

    return _this;
  }

  _createClass(UserProfileComponent, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      this.filterMenuList();
      var $wrap = document.querySelector(".".concat(prefix, "-overflow"));
      if ($wrap) $wrap.addEventListener("scroll", this.wrapScrollHandle);
      getUserInfo().then(function (res) {
        var resDate = res.data;
        transferGetData(resDate, _this2.props);

        _this2.setState({
          show: true,
          isDisable: false,
          activeMenu: _objectSpread(_objectSpread({}, _this2.state.activeMenu), {}, {
            component: LanguageAndRegin
          })
        });
      }).catch(function () {
        _this2.setState({
          show: true,
          isDisable: false,
          activeMenu: _objectSpread(_objectSpread({}, _this2.state.activeMenu), {}, {
            component: LanguageAndRegin
          })
        });
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var trans = getTransFunc();
      var _this$state3 = this.state,
          displayMenuList = _this$state3.displayMenuList,
          show = _this$state3.show,
          currentIndex = _this$state3.currentIndex,
          activeMenu = _this$state3.activeMenu,
          isDisable = _this$state3.isDisable;
      var LeftMenuList = displayMenuList.map(function (item, i) {
        return /*#__PURE__*/React.createElement("div", {
          key: i,
          className: "".concat(prefix, "-dialog-content-menu-item \n        ").concat(activeMenu.id === item.id ? "active" : "", "\n        ").concat(isDisable ? "disable" : ""),
          onClick: function onClick() {
            _this3.onClickMenuItem(item);
          }
        }, item.name);
      });
      var theme = getTheme().theme;

      if (this.props.theme) {
        theme = this.props.theme;
      }

      return /*#__PURE__*/React.createElement("span", {
        className: "sfx-react-ui-theme",
        "data-theme": theme
      }, /*#__PURE__*/React.createElement("div", {
        className: "".concat(prefix, "-mask ").concat(show ? "show" : "hide", " ")
      }, /*#__PURE__*/React.createElement("div", {
        className: "".concat(prefix, "-dialog-wrap ").concat(show ? "show" : "hide")
      }, /*#__PURE__*/React.createElement("div", {
        className: "".concat(prefix, "-dialog-title")
      }, trans('SFxUserProfileCompleteYourProfile'), /*#__PURE__*/React.createElement("span", {
        onClick: function onClick() {
          _this3.onClose(true, function () {
            if (_this3.props && _this3.props.onSolutionTour) {
              _this3.props.onSolutionTour();
            }
          });
        },
        className: "".concat(prefix, "-dialog-close")
      })), /*#__PURE__*/React.createElement("div", {
        className: "".concat(prefix, "-dialog-content-title")
      }, trans('SFxUserProfileCompleteYourProfile')), /*#__PURE__*/React.createElement("div", {
        className: "".concat(prefix, "-dialog-content")
      }, /*#__PURE__*/React.createElement("div", {
        className: "".concat(prefix, "-dialog-content-menu")
      }, LeftMenuList), /*#__PURE__*/React.createElement("div", {
        className: "".concat(prefix, "-dialog-content-menu-dropdown"),
        onClick: function onClick() {
          _this3.setState({
            showMenuDropdown: !_this3.state.showMenuDropdown
          });
        }
      }, /*#__PURE__*/React.createElement(IconBurgerMenu, null), this.state.showMenuDropdown && /*#__PURE__*/React.createElement("span", {
        className: "".concat(prefix, "-dialog-content-menu-dropdown-wrap")
      }, LeftMenuList)), /*#__PURE__*/React.createElement("div", {
        className: "".concat(prefix, "-dialog-content-content")
      }, /*#__PURE__*/React.createElement("div", {
        className: "".concat(prefix, "-dialog-content-content-title")
      }, activeMenu.name), /*#__PURE__*/React.createElement("div", {
        className: "".concat(prefix, "-dialog-content-content-form-wrap ").concat(prefix, "-overflow")
      }, show && /*#__PURE__*/React.createElement(activeMenu.component, {
        childEvent: this.childEvent,
        setDisableState: this.setDisableState,
        options: this.props,
        uploadAvatarSuccess: this.uploadImageSuccess,
        deleteAvatarSuccess: this.deleteAvatarSuccess
      })))), /*#__PURE__*/React.createElement("div", {
        className: "".concat(prefix, "-dialog-footer ").concat(this.state.scrollFlag && "show-box-shadow")
      }, /*#__PURE__*/React.createElement("div", {
        className: "".concat(prefix, "-dialog-footer-left")
      }, /*#__PURE__*/React.createElement("span", {
        onClick: this.reset
      }, trans('SFxUserProfileReset'))), /*#__PURE__*/React.createElement("div", {
        className: "".concat(prefix, "-dialog-footer-right")
      }, currentIndex !== 0 && /*#__PURE__*/React.createElement(Button, {
        size: "sm",
        disabled: isDisable,
        onClick: this.onBack
      }, trans('SFxUserProfileBack')), currentIndex === displayMenuList.length - 1 ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Button, {
        size: "sm",
        color: "primary",
        onClick: this.onFinish
      }, trans('SFxUserProfileFinish'))) : /*#__PURE__*/React.createElement(Button, {
        size: "sm",
        color: "primary",
        disabled: isDisable,
        onClick: this.onNext
      }, trans('SFxUserProfileNext')))))));
    }
  }]);

  return UserProfileComponent;
}(React.Component);

export { UserProfileComponent as default };